import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "./style.css";
import Notification from "./singleNotification";
import Animation from "../../../../shared/components/common/Animation";
import { NotFoundAnim } from "../../../../assets";
import { Spinner } from "react-bootstrap";

function NotificationModal({ openModal, HideModal, loader, listNotify }) {
  return (
    <>
      <Modal
        size="lg"
        backdrop="static"
        show={openModal}
        onHide={HideModal}
        centered
      >
        <button
          type="button"
          className="close custom-modal-close"
          onClick={HideModal}
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div className="login-form" style={{ width: "100%" }}>
          <h4 className="margin">Notifications</h4>
          {loader ? (
            <div className="notification-container overflow-auto">
              <Spinner animation="grow" size="lg" />
            </div>
          ) : listNotify && listNotify.length > 0 ? (
            <>
              <div className="notification-container overflow-auto">
                {listNotify.map((item, inx) => {
                  return <Notification key={inx} item={item} />;
                })}
              </div>
            </>
          ) : (
            <div className="pb-5">
              <Animation Pic={NotFoundAnim} Message={"No Notification Found"} />
            </div>
          )}
        </div>
      </Modal>
    </>
  );
}

export default NotificationModal;
